import SUIContext from '@s-ui/react-context'

import FeedArticlesContainer from './component.js'

export default SUIContext.wrapper(FeedArticlesContainer, 'FeedArticlesContainer')
